export enum FOMGOType {
  VLSHFO = 1,
  HSHFO = 2,
  MGO = 3,
  MDO = 4,
}

export const FOMGOTypeName = ["VLSHFO", "HSHFO", "MGO", "MDO"];
